export default __webpack_public_path__ + "static/media/menu.b9493d23.svg";